import { render, staticRenderFns } from "./AddIframeToEditor.vue?vue&type=template&id=728fb51a&scoped=true"
import script from "./AddIframeToEditor.vue?vue&type=script&lang=js"
export * from "./AddIframeToEditor.vue?vue&type=script&lang=js"
import style0 from "./AddIframeToEditor.vue?vue&type=style&index=0&id=728fb51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728fb51a",
  null
  
)

export default component.exports